import { t, tf } from "./i18n.js";
// ---------------------------------------------------------------------------
// Online-Lobby und Avatarbilder
//
// AUSGEBAUT 08.08.2026: der Handy-als-Kamera-Modus.
//
// Diese Datei hiess camera.js, weil hier der Weg lag, das eigene Handy per
// QR-Code als Webcam in ein Online-Match zu haengen (LiveKit-Stream, der
// beim Gegner im Spielerfeld erschien). Der Weg ist vollstaendig entfernt:
// QR-Code, Companion-Bildschirm, Sender, Empfaenger, Zoom-Sync und die
// LiveKit-Anbindung.
//
// Warum alles und nicht nur der QR-Code: Das Handy WAR die einzige
// Videoquelle. Ohne Sender haetten Empfaenger, Videoflaechen und
// Tokenabruf nichts mehr zu tun gehabt - toter Code, der bei jedem
// spaeteren Umbau mitgelesen und mitgedacht werden muss. Die Pakete
// livekit-client und qrcode entfallen damit ebenfalls.
//
// Uebrig bleibt, was mit Kamera nichts zu tun hat und hier nur
// historisch lag: die Online-Lobby und der Avatar-Upload.
// ---------------------------------------------------------------------------

window.isOnlineHost = false;

function openOnlineLobby(roomCode, hostName, guestName = null, isHost = false) {
  isOnlineHost = isHost;
  document
    .querySelectorAll(".container > div")
    .forEach((s) => (s.style.display = "none"));
  document.getElementById("online-lobby-screen").style.display = "block";
  document.getElementById("lobby-setup").style.display = "none";
  document.getElementById("lobby-active").style.display = "block";
  document.getElementById("lobby-room-code-display").innerText = roomCode;

  const startBtn = document.getElementById("btn-start-online-match");
  if (isHost) {
    startBtn.style.display = "block";
    startBtn.disabled = true;
    startBtn.style.opacity = "0.5";
  } else {
    startBtn.style.display = "none";
  }
  updateLobbyPlayers(hostName, guestName);
}

function updateLobbyPlayers(hostName, guestName) {
  document.getElementById("lobby-host-name").innerText = hostName || t("js.camera.003");
  const guestEl = document.getElementById("lobby-guest-name");
  const startBtn = document.getElementById("btn-start-online-match");

  if (guestName) {
    guestEl.innerText = guestName;
    guestEl.style.color = "white";
    if (isOnlineHost) {
      startBtn.disabled = false;
      startBtn.style.opacity = "1";
    }
  } else {
    guestEl.innerText = t("js.camera.004");
    guestEl.style.color = "#888";
  }
}

async function triggerOnlineMatchStart() {
  if (!isOnlineHost) return;
  document.getElementById("btn-start-online-match").innerText = t("js.camera.005");
  document.getElementById("btn-start-online-match").disabled = true;
  await _supabase
    .from("live_matches")
    .update({ status: "playing", last_action: t("js.camera.006") })
    .eq("room_code", currentRoomCode);
}

// ==========================================
// AVATAR UPLOAD & COMPRESSION ENGINE
// ==========================================
let isUploadingAvatar = false;

async function handleAvatarUpload(event) {
  if (isUploadingAvatar) return;

  const file = event.target.files[0];
  if (!file) return;

  isUploadingAvatar = true;
  const editAvatarBtn = document.getElementById("btn-edit-avatar");
  if (editAvatarBtn) editAvatarBtn.innerText = t("js.camera.002");

  try {
    const {
      data: { session },
      error: sessionError,
    } = await _supabase.auth.getSession();
    if (!session || sessionError)
      throw new Error(
        t("js.camera.001")
      );

    const compressedImageBlob = await compressImage(file, 500);
    const fileName = `${currentUser.id}.jpg`;

    const { data: uploadData, error: uploadError } = await _supabase.storage
      .from("avatars")
      .upload(fileName, compressedImageBlob, {
        contentType: "image/jpeg",
        upsert: true,
      });

    if (uploadError) throw new Error("Storage Error: " + uploadError.message);

    const {
      data: { publicUrl },
    } = _supabase.storage.from("avatars").getPublicUrl(fileName);
    const freshUrl = `${publicUrl}?t=${Date.now()}`;

    const { error: updateError } = await _supabase.auth.updateUser({
      data: { avatar_url: freshUrl },
    });
    if (updateError)
      throw new Error("Auth Update Error: " + updateError.message);

    const { error: profileError } = await _supabase.from("profiles").upsert({
      id: currentUser.id,
      name: myOnlineName,
      avatar_url: freshUrl,
    });
    if (profileError)
      throw new Error("Profile Update Error: " + profileError.message);

    if (!currentUser.user_metadata) currentUser.user_metadata = {};
    currentUser.user_metadata.avatar_url = freshUrl;

    // Alle Stellen aktualisieren, an denen das Profilbild haengt.
    // Vorher wurde nur modal-avatar-preview gesetzt - der Profil-Screen und
    // die Einstellungen zeigten weiter das alte Bild.
    ["modal-avatar-preview", "settings-avatar-preview", "profile-avatar"].forEach(
      (id) => {
        const el = document.getElementById(id);
        if (el) el.src = freshUrl;
      },
    );
    if (typeof refreshProfileScreen === "function") refreshProfileScreen();

    showToast(t("js.camera.007"), "success");
  } catch (error) {
    showToast(error.message, "error");
  } finally {
    const editBtn = document.getElementById("btn-edit-avatar");
    if (editBtn) editBtn.innerText = "EDIT";
    event.target.value = "";
    isUploadingAvatar = false;
  }
}

function compressImage(file, targetSize) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const minSize = Math.min(img.width, img.height);
        const startX = (img.width - minSize) / 2;
        const startY = (img.height - minSize) / 2;
        canvas.width = targetSize;
        canvas.height = targetSize;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(
          img,
          startX,
          startY,
          minSize,
          minSize,
          0,
          0,
          targetSize,
          targetSize
        );
        canvas.toBlob((blob) => resolve(blob), "image/jpeg", 0.85);
      };
    };
    reader.onerror = (error) => reject(error);
  });
}

// ---------------------------------------------------------------
// Bruecke zu window: Inline-Handler im HTML und andere Module greifen
// weiterhin global auf diese Funktionen zu.
//
// Entfallen am 08.08.2026 mit dem Handy-Modus: generateCameraQR,
// startCompanionMode, cleanupWebRTC, stopCameraStream. Aufrufer davon
// gab es in app.js (goHome, ?camera=-Einstieg) und in den HTML-Blocken,
// die ebenfalls entfernt wurden.
// ---------------------------------------------------------------
Object.assign(window, {
  openOnlineLobby,
  updateLobbyPlayers,
  triggerOnlineMatchStart,
  handleAvatarUpload,
});
